'use strict';

/**
 * List of available easing names available through jQuery and via 'module.exports' (e.g. AnimationEasing.easeInOutCubic):
 * <ul>
 * <li>linear
 * <li>swing
 * <li>easeInQuad
 * <li>easeOutQuad
 * <li>easeInOutQuad
 * <li>easeInCubic
 * <li>easeOutCubic
 * <li>easeInOutCubic
 * <li>easeInQuart
 * <li>easeOutQuart
 * <li>easeInOutQuart
 * <li>easeInQuint
 * <li>easeOutQuint
 * <li>easeInOutQuint
 * <li>easeInExpo
 * <li>easeOutExpo
 * <li>easeInOutExpo
 * <li>easeInSine
 * <li>easeOutSine
 * <li>easeInOutSine
 * <li>easeInCirc
 * <li>easeOutCirc
 * <li>easeInOutCirc
 * <li>easeInElastic
 * <li>easeOutElastic
 * <li>easeInOutElastic
 * <li>easeInBack
 * <li>easeOutBack
 * <li>easeInOutBack
 * <li>easeInBounce
 * <li>easeOutBounce
 * <li>easeInOutBounce
 * </ul>
 * 
 * These are based on jQueryUI. Documentation (with nice graphs): http://api.jqueryui.com/easings/
 */


/*! jQuery UI - v1.11.4 - 2016-03-12
* http://jqueryui.com
* Includes: effect.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */
// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

var AnimationEasing = {};
var baseEasings = {};

AnimationEasing.addEasing = function(name, fn) {
	AnimationEasing[name] = fn;
	
	// Configure jQuery
	function registerWithJQuery(jQuery) {
		jQuery.easing[name] = fn;
	};
	if (typeof module === 'object' && module.exports) {
		registerWithJQuery(require('jquery'));
	} else if (typeof define === "function" && define.amd) {
		define(['jquery'], registerWithJQuery);
	} else if (window.jQuery !== undefined) {
		registerWithJQuery(window.jQuery);
	} else if (this.jQuery !== undefined) {
		registerWithJQuery(this.jQuery);
	}
  
	return fn;
};

// Create an object that contains all base easing functions
var baseEasingNames = ['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'];
for (var i in baseEasingNames) {
	addBaseEasingFn(i, baseEasingNames[i]);
}
function addBaseEasingFn(i, name) {
	baseEasings[name] = function(p) {
		return Math.pow(p, i + 2);
	};
}

// Add a few specific ones;
baseEasings.Sine = function(p) {
	return 1 - Math.cos( p * Math.PI / 2 );
};
baseEasings.Circ = function(p) {
	return 1 - Math.sqrt( 1 - p * p );
};
baseEasings.Elastic = function(p) {
	return p === 0 || p === 1 ? p :
		-Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
};
baseEasings.Back = function(p) {
	return p * p * ( 3 * p - 2 );
};
baseEasings.Bounce = function(p) {
	var pow2, bounce = 4;
	while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
	return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
};

// Iterate through the base easing functions and create 'easeIn' 'easeOut' and 'easeInOut' variations
for (var name in baseEasings) {
	if (baseEasings.hasOwnProperty(name)) {
		addVariations(name, baseEasings[name])
	}
}
function addVariations(name, easeFn) {
	AnimationEasing.addEasing('easeIn' + name, easeFn);
	AnimationEasing.addEasing('easeOut' + name, function(p) {
		return 1 - easeFn( 1 - p );
	});
	var inOutFn = AnimationEasing.addEasing('easeInOut' + name, function(p) {
		return p < 0.5 ?
				easeFn( p * 2 ) / 2 :
				1 - easeFn( p * -2 + 2 ) / 2;
	});
}

// Add 'linear' and 'swing'
AnimationEasing.addEasing('linear', function(p) {
	return p;
});
AnimationEasing.addEasing('swing', function(p) {
	return 0.5 - Math.cos( p * Math.PI ) / 2;
});

// Change default easing in jQuery
if (window.jQuery) {
	window.jQuery.easing.def = 'easeOutQuad';
}

/**
 * Function that creates bezier curve
 * e.g.
 * 	AnimationEasing.addEasing('interaction', AnimationEasing.bezier(.3,1,.8,1));
 * 	AnimationEasing.addEasing('noInteraction', AnimationEasing.bezier(.4,.69,.5,1));
 */
AnimationEasing.bezier = function(mX1, mY1, mX2, mY2) {
	if (mX1 == mY1 && mX2 == mY2) {
		return function(aX) { return aX; };
	} else {
		return function(aX) { return CalcBezier(GetTForX(aX), mY1, mY2); };
	}

	function A(aA1, aA2) {
		return 1.0 - 3.0 * aA2 + 3.0 * aA1;
	}
	function B(aA1, aA2) {
		return 3.0 * aA2 - 6.0 * aA1;
	}
	function C(aA1)      {
		return 3.0 * aA1;
	}

	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function CalcBezier(aT, aA1, aA2) {
		return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	}

	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function GetSlope(aT, aA1, aA2) {
		return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	}

	// Newton raphson iteration
	function GetTForX(aX) {
		var aGuessT = aX;
		for (var i = 0; i < 4; ++i) {
			var currentSlope = GetSlope(aGuessT, mX1, mX2);
			if (currentSlope == 0.0)
				return aGuessT;
			var currentX = CalcBezier(aGuessT, mX1, mX2) - aX;
			aGuessT -= currentX / currentSlope;
		}
		return aGuessT;
	}
}

module.exports = AnimationEasing;
